import { Injectable } from '@angular/core';
import {
  DataType,
  HTTPManagerStateService,
} from 'http-request-manager';
import { environment } from '@environments/environment';
import { SystemVariable } from '../models/system-variables.model';

@Injectable({
  providedIn: 'root',
})
export class SystemVariablesService extends HTTPManagerStateService<SystemVariable> {
  constructor() {
    super(
      {
        server: environment.api,
        path: ['systemvariables'],
      },
      DataType.ARRAY,
    );
  }

  /**
   * Fetches all system variables and populates the state.
   */
  getAllSystemVariables(): void {
    this.fetchRecords();
  }

  /**
   * Creates a new system variable.
   */
  createSystemVariable(data: SystemVariable): void {
    this.createRecord(data);
  }

  /**
   * Updates the provided system variable.
   */
  updateSystemVariable(data: SystemVariable): void {
    this.updateRecord(data);
  }

  /**
   * Deletes a system variable by id.
   */
  deleteSystemVariable(data: SystemVariable): void {
    this.deleteRecord({
      path: [data?.id],
      headers: {},
    });
  }
}
